<template>
    <VcPopover
        class="w-full min-w-0"
        placement="top"
        trigger="hover"
        :disabled="!isTruncated"
        :popover-max-width="maxWidth"
    >
        <template #reference>
            <span
                ref="el"
                class="block w-full truncate"
                :class="[contentClass, { 'cursor-pointer': isTruncated }]"
                :style="contentStyle"
                :aria-label="isTruncated ? text : undefined"
                :data-testid="testId"
            >
                {{ text }}
            </span>
        </template>
        <div class="p-2">
            {{ text }}
        </div>
    </VcPopover>
</template>

<script setup lang="ts">
import { nextTick, ref, watch, type CSSProperties } from 'vue'
import { useResizeObserver } from '@vueuse/core'
import { VcPopover } from '@voicenter-team/voicenter-ui-plus'

const props = withDefaults(defineProps<{
    text: string
    contentClass?: string | Record<string, boolean> | Array<string | Record<string, boolean>>
    contentStyle?: CSSProperties
    maxWidth?: number
    testId?: string
}>(), {
    maxWidth: 320
})

const el = ref<HTMLElement | null>(null)
const isTruncated = ref(false)

function updateTruncation () {
    const node = el.value
    isTruncated.value = !!node && node.scrollWidth > node.clientWidth
}

useResizeObserver(el, updateTruncation)
watch(
    [() => props.text, () => props.contentStyle],
    () => nextTick(updateTruncation)
)
</script>
